import { calendarPropsSchema } from '../component-catalog.js';
export const calendarDefinition = {
    type: 'Calendar',
    category: 'domain',
    propsSchema: calendarPropsSchema,
    isDataBacked: true,
    columnRefManifest: ['date', 'title', 'color', 'endDate'],
    needsMeasuredDims: true,
    defaultMinHeight: 200,
    description: 'Calendar view of dated rows. Props: sourceDataset (required), mapping ({ date: string, title: string, color?: string, endDate?: string }), view? ("month" | "week").',
};
//# sourceMappingURL=Calendar.js.map